import React from "react";
import ReactDOM from "react-dom";
import LoadApp from "./LoadApp";
import { Provider } from "react-redux";
import { StoreUtils } from "funkis-foundation";

import { store } from "./app/store";

StoreUtils.setStore(store);

ReactDOM.render(
	<Provider store={store}>
		<React.StrictMode>
			<LoadApp />
		</React.StrictMode>
	</Provider>,
	document.getElementById("root")
);
